<template>
  <div class="box10-page">
    <pageTitle
      title="顺势而为  你也可以"
      tit="现在仍是入行好时机！"
    ></pageTitle>
    <div class="content common-animation">
      <div class="wrapper">
        <ul>
          <li v-for="item in list" :key="item.tit">
            <img :src="item.img" alt="">
            <h3>{{item.tit}}</h3>
            <p>{{item.txt}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="btn" @click="childMethod">立即咨询报名</div>
  </div>
</template>

<script>
  import pageTitle from "../../../components/common/pageTitle.vue";
  export default {
    name: '',
    components: {
      pageTitle
    },
    data() {
      return {
        list: [
        {
          img: require("../../../assets/topic-page/newMedia2/box10/01.png"),
          tit: "创业老板/向往自由的人群",
          txt: "有货源/无货源创业人群，无运营能力，需快速获取流量。追求更灵活、更自由轻松工作环境的自由职业者。",
        },
        {
          img: require("../../../assets/topic-page/newMedia2/box10/02.png"),
          tit: "稳定上班族",
          txt: "有较稳定工作，想充分利用业余时间发展副业，增加保障，拓宽收入。",
        },
        {
          img: require("../../../assets/topic-page/newMedia2/box10/03.png"),
          tit: "具备某方面能力特长人群",
          txt: "在某领域有一定特长或经验，有明显个性化特征人群，更容易快速上手。",
        },
        {
          img: require("../../../assets/topic-page/newMedia2/box10/04.png"),
          tit: "不便进入职场人群",
          txt: "宝妈、退休老人等不具备进入职场条件的人群，在家也能玩网络，创收入！",
        },
        {
          img: require("../../../assets/topic-page/newMedia2/box10/05.png"),
          tit: "初入职场迷茫者",
          txt: "初入新媒体行业，把控不了准确的运营节奏，需要专业人士陪跑、指导，掌握引流变现技巧。",
        },
      ],
      }
    },
    methods: {
      childMethod() {
        this.$parent.itcastClick();
      }
    },
  }
</script>

<style lang="scss" scoped>
.box10-page {
  margin: 0 auto;
  padding: 75px 0px;
  max-width: 2048px;
  height: 739px;
  box-sizing: border-box;
  background: url("../../../assets/topic-page/newMedia2/box10/bg.jpg") no-repeat;
  background-size: 2048px 739px;
  background-position: center;
  .btn{
      width: 207px;
      height: 56px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 56px;
      border-radius: 28px;
      font-weight: bold;
      box-sizing: border-box;
      box-shadow: 0 8px 7px #e2b8db;
      background: url("../../../assets/topic-page/newMedia2/btnbg1.png") no-repeat;
      cursor: pointer;
      margin: 40px auto 0;
      padding-right: 20px;
      &:hover{
        box-shadow: none;
      }
    }
  h1{
    font-family: PingFang-SC-Bold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 1px;
    color: #000000;
    text-align: center;
  }
  h2{
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 1px;
    color: #333333;
    text-align: center;
    margin: 18px 0 62px;
  }
  .content {
    margin: 60px auto 0;
  }
  .wrapper {
    width: 1200px;
	  height: 350px;
    margin: 0 auto;
    background-color: #ffffff;
    box-shadow: 0px 10px 20px 0px #f6edf0;
    border-radius: 20px;
    ul {
      display: flex;
    }
  }
  li {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 15px;
    position: relative;
    img {
      width: 136px;
	    height: 136px;
    }
    h3 {
      font-family: PingFang-SC-Bold;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 18px;
      letter-spacing: 0px;
      color: #000000;
      margin-bottom: 20px;
    }  
    p {
      width: calc(100% - 60px);
      font-family: PingFang-SC-Regular;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 22px;
      letter-spacing: 0px;
      color: #253326;
      text-align: left;
    }
    &:not(:last-child)::after {
      position: absolute;
      right: 0;
      top: 63px;
      display: block;
      content: '';
      width: 1px;
      height: 224px;
      background: url('../../../assets/topic-page/newMedia2/box10/line.png') no-repeat center;
      background-size: 100% 100%;
    }   
  }
} 
</style>